import $ from 'jquery';

export default {
  init: function() {
    /**
     * Toggle body classes for off-canvas navigation
     */
    var $body = $('body');
    var $page = $('.page');
    //var $toggle = $('[data-toggle-offcanvas]');

    var offCanvasClasses = [];

    var viewport = $('head meta[name="viewport"]'),
        viewPortDefaultVal = viewport.attr('content');

    var reset = function(){
      var removeClasses = 'offcanvas-open ';
      for (var i = 0; i < offCanvasClasses.length; i++) {
        removeClasses += (' ' + offCanvasClasses[i]);
      }
      $body.removeClass(removeClasses);
      offCanvasClasses = [];

      //Set default viewport back
      viewport.attr('content', viewPortDefaultVal);
    };

    //$toggle.on('click', function(e){
    $body.on('click', '[data-toggle-offcanvas]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var className = $(this).data('toggleOffcanvas'), //which off canvas is in question
          focusElement = $(this).data('focusOffcanvas'); //Which element to set focus on

      if(offCanvasClasses.indexOf(className) === -1){
        //Opening offcanvas
        offCanvasClasses.push(className);
        $body.addClass(className);

        //Set focus to opened off canvas element
        if(focusElement) {
          $(focusElement).attr('tabindex', '-1').focus();
        }

        //Set iframe url from the toggle href
        if($(this).is('.iframe-url')) {
          if($('.offcanvas-share-email iframe').attr('src') === '') {
            $('.offcanvas-share-email iframe').attr('src', this.href);
          }

          //Don't allow zooming while this iframe is open
          viewport.attr('content', 'width=device-width, height=device-height, initial-scale=1.0, maximum-scale=1.0');
        }
      }else {
        //Closing offcanvas
        var index = $.inArray(className, offCanvasClasses);
        if(index !== -1) {
          offCanvasClasses.splice(index, 1);
        }
        $body.removeClass(className);

        //Set focus to toggle button
        if(focusElement) {
          $(focusElement).focus();
        }

        //Set default viewport back
        viewport.attr('content', viewPortDefaultVal);
      }

      if(offCanvasClasses.length > 0) {
        $body.addClass('offcanvas-open');
      } else {
        // Wait for transition duration before removing
        setTimeout(function() {
          $body.removeClass('offcanvas-open');
        }, 300);
      }


      //$body.toggleClass('offcanvas-open', offCanvasClasses.length > 0); //If array has items, add this class. If array is empty, remove.

    });

    $page.on('click', function(e){
      if($body.hasClass('offcanvas-open')){
        e.preventDefault();
        reset();
      }
    });

    $(window).on('resize', function(){
      if(offCanvasClasses.length > 0 && $(window).width() > 641){
        reset();
      }
    });

  }
};
